import _ from 'lodash';

const blockListedItemIdTypes = {
    IHM: ['UNKNOWN', 'RFID'],
    JANE: ['UNKNOWN', 'RFID', 'PLU'],
};
export class StoreFamily {
    public static StoreFamily = Object.freeze({
        IHM: 'IHM',
        JANE: 'JANE',
        MENDEL: 'MENDEL',
        WFM: 'WFM',
        KISAN: 'KISAN',
        ASSET: 'ASSET',
        HOUDINI: 'HOUDINI',
        UV: 'UV',
        KASPIAN: 'KASPIAN',
        DOROTHY: 'DOROTHY',
        ROADIE: 'ROADIE',
        SSD: 'SSD',
    });

    public static isItemIdAllowedForStoreFamily(itemIdType, storeFamily): boolean {
        return !_.includes(blockListedItemIdTypes[storeFamily], itemIdType);
    }
}
